import { DEFAULT_APPEARANCE, PRESETS, useAppearance, type Theme } from "../lib/appearance";
import { Icon } from "../components/Icon";
import { RadioGroup, Slider, Switch } from "../components/rumonai";
import "../connections/settings-list.css";
import "./AppearanceSettings.css";

/**
 * 外观: the mode, the palette and the painting. One soft card of three parts; a choice takes effect the moment it is
 * made, so there is nothing to save and the only button is the way back to how it came.
 */
export function AppearanceSettings() {
  const { value, onChange } = useAppearance();
  return <section className="settings-group appearance-settings" aria-labelledby="appearance-title">
    <header className="appearance-head">
      <div><h2 id="appearance-title" className="settings-group-title">外观</h2>
        <p className="settings-group-note">用于所有 Agent 与工作界面，保存在这台浏览器。</p></div>
      <button className="btn btn-quiet" type="button" onClick={() => onChange({ ...DEFAULT_APPEARANCE })}>恢复默认</button>
    </header>
    <div className="settings-list appearance-card">
      <div className="settings-row appearance-line">
        <div className="settings-row-main"><span className="settings-row-title">显示模式</span></div>
        <RadioGroup className="appearance-mode" label="显示模式" name="appearance-mode" value={value.theme}
          orientation="horizontal" onValueChange={mode => onChange({ ...value, theme: mode as Theme })}
          items={[{ value: "system", label: "跟随系统" }, { value: "light", label: "浅色" }, { value: "dark", label: "深色" }]} />
      </div>
      {(["light", "dark"] as const).map(mode => <fieldset className="appearance-presets" key={mode}
        onClick={event => {
          const selected = (event.target as HTMLElement).closest(".pa-radio-choice")?.querySelector('[role="radio"][data-state="checked"]');
          if (selected && value.theme !== mode) onChange({ ...value, theme: mode });
        }}>
        <legend>{mode === "light" ? "浅色主题" : "深色主题"}</legend>
        <RadioGroup className="appearance-theme-grid" label={mode === "light" ? "浅色主题" : "深色主题"}
          name={`appearance-${mode}`} value={value[mode]} onValueChange={preset => onChange({ ...value, [mode]: preset, theme: mode })}
          items={PRESETS.filter(p => p.mode === mode).map(p => ({ value: p.id, label: <>
          <span className="appearance-preview" data-palette={p.id} aria-hidden="true">
            <img className="appearance-preview-rail" src={`/brand/${p.id}-sidebar.webp`} alt="" loading="lazy" />
            <img className="appearance-preview-edge" src={`/brand/${p.id}-edge.webp`} alt="" loading="lazy" />
            <span className="appearance-preview-content"><i /><i /><b /><i /></span>
            <Icon name="yes" size={14} />
          </span>
          <span className="appearance-choice-name">{p.name}</span>
        </> }))} />
      </fieldset>)}
      <div className="settings-row appearance-line">
        <Switch className="appearance-artwork" label="背景图案" name="artwork" checked={value.artwork}
          onCheckedChange={artwork => onChange({ ...value, artwork })} /></div>
      <div className="settings-row appearance-line appearance-intensity"><span className="settings-row-main"><span className="settings-row-title">右侧浓淡</span></span>
        <span className="appearance-slider"><Slider label="右侧浓淡" min={0} max={20} step={1} value={value.edgeOpacity} disabled={!value.artwork}
          aria-valuetext={`${value.edgeOpacity}%`} onValueChange={edgeOpacity => onChange({ ...value, edgeOpacity })} /><output className="num">{value.edgeOpacity}%</output></span></div>
    </div>
    <div className="settings-row appearance-line"><Switch label="减少动态" name="reduced-motion" checked={Boolean(value.reducedMotion)}
      onCheckedChange={reducedMotion => onChange({ ...value, reducedMotion })} /></div>
    <p className="appearance-saved" role="status">选择即生效</p>
  </section>;
}
